angular.module('zc.zenclerkS')
  .controller('ZcsInvoicesController', ZcsInvoicesController);

ZcsInvoicesController.$inject = ['currencies', 'invoices', 'project'];
function ZcsInvoicesController(currencies, invoices, project) {
  const vm = this;
  vm.invoices = invoices;
  vm.project = project;
  vm.thisMonth = moment().format('YYYY-MM');
  vm.currencies = currencies;
  const currentMonth = moment().startOf('month');

  vm.isTerminated = false;
  if(project.terminated_at && currentMonth.isSameOrAfter(moment(project.terminated_at))) {
    vm.isTerminated = true;
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/invoices/list/invoices.controller.js